import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import AdminRoutes from "./Routes/AdminRoutes";
import FontRoutes from "./Routes/FontRoutes";
import ProtectedRoute from "./Routes/ProtectedRoute";
import LoginModal from "./Font/components/LoginModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
      <Routes>

        {/*  LOGIN ROUTE */}
        <Route path="/adminlogin" element={< LoginModal />} />

        {/*  PROTECTED ADMIN */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        {/* FRONT */}
        <Route path="/*" element={<FontRoutes />} />

      </Routes>
    </BrowserRouter>
  );
}
export default App;
